export default __webpack_public_path__ + "static/media/Shine.71ef35ce.webp";